export default {
  pageTitle: '限时促销',
  manageTitle: '限时促销管理',
  productsTitleTab: '限时促销商品待选池',
  manageTitleTab: '限时促销商品管理',
  sTitle: '请输入商品标题',
  sListingId: '请输入 Listing ID',
  sSkuId: '请输入 SKU ID',
  sStartTime: '开始时间',
  sEndTime: '结束时间',

  tbListingId: 'Listing ID',
  tbProductInfo: '商品信息',
  tbSalePrice: '销售价',
  tbDealPrice: '活动价',
  tbStock: '库存',
  tbSkuInfo: 'SKU 信息',
  tbStatus: '状态',
  tbActivateTime: '活动时间',
  tbAction: '操作',
  tbErr: '异常信息',
  errTips1: '活动价必须 > 0',
  errTips2: '活动价必须低于销售价',
  errTips3: '活动时间不能为空',
  errTips4: '活动结束时间必须大于开始时间',
  errTips5: '活动整体持续时长不可超过30天',
  errTips6: '限购件数必须大于0',
  limitPerOrder: '单次限购件数',
  limitPerOrderPlaceholder: '请选择限购件数',
  limitPerOrderOption0: '不限制',
  limitPerOrderOption1: '限购1件',
  limitPerOrderOption2: '限购2件',
  limitPerOrderOption3: '限购3件',
  limitPerOrderOption4: '限购4件',
  limitPerOrderOption5: '限购5件',

  status0: '全部',
  status1: '进行中',
  status2: '已过期',
  status3: '未开始',

  succTips: '操作成功',
  errTips: '提交失败，部分SKU不符合报名要求，Sku id: {ids}',
  fixedAmount: '金额',
  discount: '折扣',
  batchSetting: '批量设置促销信息',
  reduce: '立减',

  searchBtn: '查询',
  resetBtn: '重置',
  submitBtn: '提交',
  cancelBtn: '取消',
  editBtn: '编辑',
  confirm: '确认',
  delBtn: '删除',
  previewActivateBtn: '点击查看其它活动',

  an: '按',
  cancelTips: '确认取消吗？',
  delTips: '确认删除吗？',
  submitTips: '确认提交吗？',
  closeTips: '提示',
  closeDialog: '关闭后内容将会清空，确认关闭吗？'
}
